import 'jquery-match-height';
import { nStellar } from './libs/jquery.stellar';


export default function loadThirdPartyPlugins(){
	let w = window.innerWidth
		|| document.documentElement.clientWidth
		|| document.body.clientWidth;
	
	if (w > 991) {
		$.stellar();
		$('.match-one, .match-two').matchHeight({byRow: true});
		$('.JS_pros-homepage-col').matchHeight({byRow: false});
		$('.mh').matchHeight({byRow: false});
	}
    
    if (w > 767) {
        $('.match-doc').matchHeight({byRow: false});
	}
	
	if (w > 500) {
        $('.news_mh').matchHeight({byRow: false});
	}
	
    $('.colorbox').colorbox({
        maxWidth: '95%',
        maxHeight: '95%',
	    current: "{current} / {total}",
    });

    $('a.popup').colorbox({
        iframe: true,
        innerWidth: 1920,
        innerHeight: 1080,
        maxWidth: '95%',
        maxHeight: '95%',
        rel: 'nofollow'
    });
	
	$('.js-colorbox-video').colorbox({
		iframe: true,
		innerWidth: 900,
		innerHeight: 500,
		maxWidth: '95%',
		maxHeight: '95%',
		rel: 'nofollow'
	});

}


// WEBPACK FOOTER //
// ./js/core/thirdpartyplugins.js